import store from '@/store';

export default class AgentChatLogoffEvent {
  constructor(body) {
    if (body.chatLogoff) return store.dispatch('channel/disconnectedChat');

    const error = {
      text: 'channelChat.errorDisconnect',
      type: 'error',
    };
    store.dispatch('showSnackbar', error);
  }
}
